// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import TestimonialsGrid from "../common/Testimonials";

type $Props = {
  records: Array<Object>,
  theme: Object,
};

const Testimonials = ({ records, theme }: $Props) => {
  return (
    <GlobalProvider theme={theme}>
      <TestimonialsGrid testimonials={records} />
    </GlobalProvider>
  );
};

export default Testimonials;
